import PageCompiler from '@edools/page-compiler'
import lodashIsEmpty from 'lodash.isempty'
import lodashMerge from 'lodash.merge'
import lodashCloneDeep from 'lodash.clonedeep'
import moment from 'moment-timezone'
import { uuid } from 'vue-uuid'

const TABS = PageCompiler.defaults.tabs

export default (id, options, siblings) => {
  const tabs = lodashCloneDeep(TABS)

  tabs.id = 'tabs-id'
  tabs.title = 'Transmissões'
  tabs.type = 'Tabs'

  tabs.id = id
  tabs.options.sm.position = siblings.length
  tabs.options.md.position = siblings.length
  tabs.options.lg.position = siblings.length

  tabs.items = [
    {
      id: uuid.v1(),
      title: 'Webinar 1',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus hendrerit',
      button: 'Assistir',
      date: moment().format('YYYY-MM-DD'),
      time: moment().format('HH:mm:ss'),
      options: {
        sm: {
          dateColor: '#55BDCA',
        },
        md: {
          dateColor: '#55BDCA',
        },
        lg: {
          dateColor: '#55BDCA',
        },
      },
    },
    {
      id: uuid.v1(),
      title: 'Webinar 2',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus hendrerit',
      button: 'Assistir',
      date: moment().format('YYYY-MM-DD'),
      time: moment().format('HH:mm:ss'),
      options: {
        sm: {
          dateColor: '#55BDCA',
        },
        md: {
          dateColor: '#55BDCA',
        },
        lg: {
          dateColor: '#55BDCA',
        },
      },
    },
    {
      id: uuid.v1(),
      title: 'Webinar 3',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus hendrerit',
      button: 'Assistir',
      date: moment().format('YYYY-MM-DD'),
      time: moment().format('HH:mm:ss'),
      options: {
        sm: {
          dateColor: '#FF305C',
        },
        md: {
          dateColor: '#FF305C',
        },
        lg: {
          dateColor: '#FF305C',
        },
      },
    },
  ]

  const isEmpty = !lodashIsEmpty(options)

  if (isEmpty) {
    lodashMerge(tabs.options, options)
  }

  return tabs
}
